<template>
  <div class="d-inline-flex align-center social-name-display">
    <span class="text--truncate">{{ formattedDisplayName }}</span>
    <v-tooltip v-if="hasSocialName" bottom color="primary">
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          x-small
          color="primary"
          class="ml-1"
          v-bind="attrs"
          v-on="on"
        >
          mdi-information-slab-circle-outline
        </v-icon>
      </template>
      <span>{{ formattedCivilName }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import Formatters from '@/shared/formatters/formatters';

export default {
  name: 'SocialNameDisplay',

  props: {
    civilName: {
      type: String,
      default: null,
    },
    socialName: {
      type: String,
      default: null,
    },
    fallback: {
      type: String,
      default: '-',
    },
  },

  computed: {
    hasSocialName() {
      return Boolean(this.normalizeValue(this.socialName));
    },
    formattedCivilName() {
      return this.formatName(this.civilName);
    },
    formattedDisplayName() {
      return this.formatName(this.hasSocialName ? this.socialName : this.civilName);
    },
  },

  methods: {
    normalizeValue(value) {
      if (value === null || value === undefined) {
        return null;
      }

      const normalizedValue = String(value).trim();
      return normalizedValue.length > 0 ? normalizedValue : null;
    },
    formatName(value) {
      const normalizedValue = this.normalizeValue(value);

      if (!normalizedValue) {
        return this.fallback;
      }

      return this.formatter.formatToTitleCase(normalizedValue);
    },
  },

  created() {
    this.formatter = new Formatters();
  },
};
</script>

<style scoped>
.social-name-display {
  max-width: 100%;
}
</style>
